import { render, staticRenderFns } from "./invPayment.vue?vue&type=template&id=1124de5c"
import script from "./invPayment.vue?vue&type=script&lang=js"
export * from "./invPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports